const ZIP_CODE_REGEXP = /^(?:[a-zA-Z0-9]+([- ]?[a-zA-Z0-9]+)*)?$/;
// eslint-disable-next-line no-useless-escape
// const PHONE_REGEXP = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im;

export const isRequired = value => (value || '').trim().length > 0;

export const isZipValid = value => {
  if (!isRequired(value)) return false;
  return ZIP_CODE_REGEXP.test((value || '').trim());
};

export const isPhoneValid = value => isRequired(value);
// if (!isRequired(value)) return false;
// return PHONE_REGEXP.test(value);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/utils/validation.js